// 敏感词列表（可扩展，也可从后端加载）
const SENSITIVE_WORDS = [
  '辱骂', '攻击', '暴力', '色情', '赌博', '毒品',
  // 添加更多敏感词...
];

/**
 * 过滤敏感词，替换为 ***
 * @param {string} text 原始文本
 * @returns {string} 过滤后的文本
 */
export function filterSensitive(text) {
  if (!text) return text;
  let filtered = text;
  SENSITIVE_WORDS.forEach((word) => {
    const regex = new RegExp(word, 'gi');
    filtered = filtered.replace(regex, '***');
  });
  return filtered;
}

/**
 * 检查文本是否包含敏感词
 * @param {string} text 原始文本
 * @returns {boolean}
 */
export function hasSensitiveWord(text) {
  if (!text) return false;
  return SENSITIVE_WORDS.some((word) => text.toLowerCase().includes(word.toLowerCase()));
}
